import { useEffect } from 'react';
import { useCounterpartiesService } from '#/unified-rfqs/contexts/counterparties';
import { useObservable } from '@paradigm/utils/src/hooks';
import { FormOption } from '#/unified-rfqs/ui/rfq-builder/types';
import { DrfqVenueCode } from '#/unified-rfqs/entities/drfq/domain';
import {
  useRfqFiltersFormActions,
  useRfqFiltersFormView,
} from '../form-context';

export function useCounterpartiesOptions() {
  const cpsService = useCounterpartiesService();
  const storedCps = useObservable(cpsService.store.list());
  const formActions = useRfqFiltersFormActions();
  const { venues } = useRfqFiltersFormView();

  // Fetch counterparties when venues change
  const selectedVenueValue =
    (venues.selectedOptions[0]?.value as DrfqVenueCode | undefined) ?? 'DBT';
  useEffect(() => {
    cpsService.fetchCps(selectedVenueValue).catch((error) => {
      console.error('Failed to fetch counterparties:', error);
    });
  }, [cpsService, selectedVenueValue]);

  // Update options when storedCps changes
  useEffect(() => {
    if (!Array.isArray(storedCps) || !storedCps.length) return;

    const counterpartyOptions: FormOption<string>[] = storedCps.map((cp) => ({
      value: cp.data.desk_name,
      label: `${cp.data.firm_name} - ${cp.data.desk_name}`,
    }));

    formActions.updateCounterparties('counterparties', counterpartyOptions);
  }, [storedCps, formActions]);
}
